import React, { Component } from 'react'
import axios from 'axios'
import { convertFromHTML } from 'draft-convert'
import { stateFromHTML } from 'draft-js-import-html'

import {
    EditorState,
    ContentState,
    convertFromRaw,
    convertToRaw,
} from 'draft-js'
import htmlToDraft from 'html-to-draftjs'
import Product from '../components/Product'
import { FETCH_STATUS } from '../constants'
import { convertLineBreaks } from '../utils'

const options = {
    htmlToStyle: (nodeName, node, currentStyle) => {
        if (nodeName === 'span' && node.style.textDecoration === 'underline') {
            return currentStyle.add('UNDERLINE')
        } else if (nodeName === 'ins') {
            return currentStyle.add('UNDERLINE')
        } else {
            return currentStyle
        }
    },
    htmlToEntity: (nodeName, node, createEntity) => {
        if (nodeName === 'a') {
            return createEntity('LINK', 'MUTABLE', {
                url: node.href,
                target: node.target,
            })
        }
    },
}

class ProductContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            products: props.products,
            status: FETCH_STATUS.NOT_STARTED,
            product: {},
            editorState: null,
            filterText: '',
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.productId !== nextProps.productId) {
            this.fetchProduct(nextProps.productId)
        }
    }

    onFilter = e => {
        const filterText = e.target.value
        const products = this.props.products.filter(
            p => p.title.toLowerCase().indexOf(filterText.toLowerCase()) >= 0,
        )
        this.setState({ filterText, products })
    }

    onChange = text => {
        const contentState = convertFromRaw(text)
        const state = EditorState.createWithContent(contentState)
        this.setState({
            editorState: state,
        })
    }

    onEditorStateChange = editorText => {
        this.setState({
            editorState: editorText,
        })
    }

    fetchProduct = id => {
        this.setState({ status: FETCH_STATUS.REQUESTED })
        Promise.resolve(
            id === 1
                ? {
                      data: {
                          products: [
                              { description: '', id: 1, title: 'New Product' },
                          ],
                      },
                  }
                : axios.get(
                      `https://9x3p2gpkxc.execute-api.us-west-1.amazonaws.com/Prod/product?products=${id}`,
                  ),
        )
            .then(response => {
                let description = response.data.products[0].description
                description = description.split('\n').join('<br />')
                const contentState = convertFromHTML({ ...options })(
                    `<p>${description}</p>`,
                    true,
                )
                const editorState = EditorState.createWithContent(contentState)
                this.setState({
                    status: FETCH_STATUS.SUCCEEDED,
                    product: response.data.products[0],
                    products: this.props.products,
                    editorState,
                    filterText: '',
                })
            })
            .catch(e => {
                console.error(e)
                this.setState({ status: FETCH_STATUS.FAILED })
            })
    }

    render() {
        return (
            <Product
                status={this.state.status}
                editorState={this.state.editorState}
                {...this.state.product}
                products={this.state.products}
                onChange={this.onChange}
                onFilter={this.onFilter}
                filterText={this.state.filterText}
                onEditorStateChange={this.onEditorStateChange}
                preview={this.props.preview}
            />
        )
    }
}

export default ProductContainer



// WEBPACK FOOTER //
// ./src/containers/ProductContainer.js